<template>
  <div>
    <CallHelpTel />
  </div>
  <div class="container">
    <div class="wrapper">
      <Title :data="IntroMessagr" />
      <Date :data="IntroMessagr" />
      <div class="article">
        <div
          class="article_item"
          v-for="Introduction in IntroList"
          :key="Introduction.fileId"
        >
          <div class="pic">
            <template
              v-for="(image, index) in Introduction.imageFiles"
              :key="index"
            >
              <img :src="image.filePath" alt="" />
            </template>
          </div>
          <div class="txt">
            <p
              :style="{ fontSize: fontSize.p + 'em' }"
              v-html="Introduction.pageContent"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
import Date from "../components/Date.vue";
import Title from "../components/Title.vue";
import { reactive } from "vue";
import { apiCenterAbout } from "@/api/api.js";
import CallHelpTel from "../components/Home/CallHelpTel.vue";

export default {
  name: "About",
  components: {
    Title,
    Date,
    CallHelpTel,
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    //中心內容
    const IntroMessagr = reactive({
      pageTitle: "",
      pagePublishUp: "",
      nodeName: "",
    });
    const IntroList = reactive([]);
    apiCenterAbout()
      .then((res) => {
        IntroList.push(res.data);
        IntroMessagr.pageTitle = res.data.pageTitle;
        IntroMessagr.pagePublishUp = res.data.pagePublishUp;
        IntroMessagr.nodeName = res.data.nodeName;
      })
      .catch((err) => {
        console.log(err);
      });

    return {
      IntroList,
      IntroMessagr,
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
img {
  margin: 10px 0;
}
.article {
  margin: 0 80px;
  @include xl {
    margin: 0 40px;
  }
  @include md {
    margin: 0;
  }
  .article_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 0;
  }
  .pic {
    // width: 50%;
    height: 315px;
    object-fit: scale-down;
    margin: 10px;
    overflow: hidden;
    @include xl {
      width: 70%;
      height: 100%;
      margin: 10px 0;
    }
    @include lg {
      width: 100%;
      margin: 10px 10px 0 10px;
    }
    @include md {
      width: 100%;
    }
    img {
      width: 100%;
      vertical-align: bottom;
    }
  }
  .txt {
    width: 70%;
    margin: 10px;
    text-align: left;
    @include lg {
      width: 100%;
    }
  }
}
</style>
